import { Helmet } from 'react-helmet-async';

const SEO = ({ title, description, path = '' }) => {
  const siteTitle = 'Trustar Industrial Chemicals';
  const fullTitle = title ? `${title} | ${siteTitle}` : `${siteTitle} | Premium TiO2 & Specialty Pigment Distributor`;
  const fullDescription = description || 'Global distributor of Titanium Dioxide and specialty pigments — Tinergy, Titax, and Albalux — serving manufacturers across the Middle East, Africa, and Latin America.';
  const canonical = `https://trustarchem.com${path}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={fullDescription} />
      <link rel="canonical" href={canonical} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={fullDescription} />
      <meta property="og:url" content={canonical} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={fullDescription} />
    </Helmet>
  );
};

export default SEO;
